import React, { FC } from 'react'

import { Alert } from '@app/types/alert'
import { AppIcon } from '@app/components/AppIcon'
import { useTimeController } from '@app/hooks/contexts/timeController/TimeControllerContext'

import theme from '../../../../../../../theme'
import AppAlertBase from '../../../../../../../components/AppAlertBase'
import AlertEventTime from '../../../../../../../components/AlertEventTime'

interface SidebarScreeningAlertProps {
	readonly alert: Alert
}

const SidebarScreeningAlert: FC<SidebarScreeningAlertProps> = ({
	alert,
}: SidebarScreeningAlertProps) => {
	const {
		formatters: { df },
	} = useTimeController()
	const eventTime = df(alert.op?.addedTimestamp)

	const title = alert.data?.alert_description
		? `Screening - ${alert.data?.alert_description}`
		: ''

	return (
		<>
			<AppAlertBase
				iconSlot={
					<AppIcon
						type={'painLevelHighSmile'}
						width={28}
						height={28}
					/>
				}
				iconBoxSx={{
					bgcolor: theme.palette.secondary.light,
					height: 'auto',
				}}
				title={title}
			/>

			<AlertEventTime eventTime={eventTime} />
		</>
	)
}

export default SidebarScreeningAlert
